import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  updateAvatarSuccess,
  updateAvatarFailed,
  UPDATE_AVATAR_START,
} from '../../actions/profile'

/**
 * update avatar api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const updateAvatarApi = (props) => {
  var uri = `/admin/profile/avatar/${props?.id}`
  return api.put(uri, props?.params)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doUpdateAvatar(action) {
  try {
    const response = yield call(updateAvatarApi, action?.payload)
      yield put(updateAvatarSuccess(response?.data))

      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess(response?.data)
      }
  } catch (error) {
    yield put(updateAvatarFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch update avatar
 */
export default function* watchUpdateAvatar() {
  yield takeLatest(UPDATE_AVATAR_START, doUpdateAvatar)
}
